import axios from "axios";
import ApiUrls from "../helper/ApiUrls";
import siteConfig from "../config/siteConfig";
import { TOKEN, REFRESH_TOKEN } from "../config/config";

export const CHAT_API = axios.create({
    baseURL: siteConfig.base_urls.chat_api,
    timeout: 300000,
    headers: {
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*"
    },
})

export const API = axios.create({
    baseURL: siteConfig.base_urls.api,
    timeout: 300000,
    headers: {
        "Authorization": `Bearer ${localStorage.getItem(TOKEN)}`,
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*"
    }
})
export const FILE_API = axios.create({
    baseURL: siteConfig.base_urls.api,
    timeout: 300000,
    headers: {
        "Authorization": `Bearer ${localStorage.getItem(TOKEN)}`,
        "Content-Type": "multipart/form-data",
        // "Access-Control-Allow-Origin": "*"
    }
})

API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${localStorage.getItem(TOKEN)}`
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// axios interceptor for refreshing access/id token
API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalConfig = error.config;
        if ((error?.response?.status === 401 || error?.response?.status === 403) && !originalConfig?._retry) {
            originalConfig._retry = true;
            try {
                const updateTokenRes = await PUBLIC_API.post(`${ApiUrls.REFRESH_TOKEN}`,{},{headers:{Authorization:`Bearer ${localStorage.getItem(REFRESH_TOKEN)}`}});
                const { idToken } = updateTokenRes.data.data;
                localStorage.setItem(TOKEN, idToken);
                error.response.config.headers.Authorization = `Bearer ${idToken}`;
                return API(error.response.config);
            } catch (_error) {
                if (error.response.status === 401) {
                    localStorage.clear();
                    window.location.replace('/');
                }
                return Promise.reject(_error);
            }
        }
        return Promise.reject(error);
    }
);

FILE_API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${localStorage.getItem(TOKEN)}`
        }
        return config;
    },
    (error) => Promise.reject(error)
);
export const PUBLIC_API = axios.create({
    baseURL: siteConfig.base_urls.api,
    timeout: 300000,
    headers: {
        "Content-Type": "application/json"
    }
})

export const PUBLIC_FORM_API = axios.create({
    baseURL: siteConfig.base_urls.api,
    timeout: 300000,
    headers: {
        "Content-Type": "multipart/form-data",
    }
})